/* src/app/admin-dashboard/notifications-list/notifications-list.component.css */
.filter-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  padding: 8px 4px 0;
}
.filter-field {
  min-width: 160px;
}
.search-field {
  min-width: 260px;
  flex: 1 1 260px;
}
.range-field {
  min-width: 260px;
}
.toggle-group {
  height: 40px;
}
.filter-bar .spacer {
  flex: 1 1 auto;
}
.summary-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding: 4px 4px 12px;
  color: #555;
  font-size: 0.9em;
  border-bottom: 1px solid #eee;
}
.summary-bar .range {
  font-weight: 600;
  color: #333;
}
.summary-bar strong {
  color: #007BFF;
}
.empty-state {
  padding: 40px;
  text-align: center;
  color: #777;
}
.card-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  padding: 20px 0;
}
@media (max-width: 1200px) {
  .card-container {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 800px) {
  .card-container {
    grid-template-columns: 1fr;
  }
}
.card {
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: transform 0.2s;
}
.card:hover {
  transform: translateY(-5px);
}
.card-header {
  background: #007BFF;
  color: #fff;
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}
.card-header h2 {
  margin: 0;
  font-size: 1.2em;
}
.count-badge {
  background: rgba(255, 255, 255, 0.25);
  border-radius: 12px;
  padding: 2px 10px;
  font-size: 0.85em;
  font-weight: 600;
  white-space: nowrap;
}
.card-body {
  padding: 15px;
}
.notification {
  position: relative;
  margin-bottom: 15px;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
  padding-right: 44px;
}
.notification:last-child {
  border-bottom: none;
  margin-bottom: 0;
}
.notification h3 {
  margin: 0 0 5px;
  font-size: 1em;
}
.notification p {
  margin: 0;
  font-size: 0.9em;
}
.notification .message {
  color: #555;
  margin-top: 5px;
}
.row-count {
  position: absolute;
  top: 0;
  right: 0;
  background: #f1f3f5;
  color: #333;
  border-radius: 12px;
  padding: 2px 9px;
  font-size: 0.8em;
  font-weight: 600;
}
.list-container {
  padding: 20px 0;
  overflow-x: auto;
}
.stockout-table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow: hidden;
}
.stockout-table th,
.stockout-table td {
  text-align: left;
  padding: 10px 14px;
  border-bottom: 1px solid #eee;
  font-size: 0.9em;
  white-space: nowrap;
}
.stockout-table th {
  background: #f8f9fa;
  font-weight: 600;
  color: #333;
}
.stockout-table tbody tr:hover {
  background: #f5f9ff;
}
.stockout-table tbody tr.stock-left td {
  color: #999;
}
/*# sourceMappingURL=notifications-list.component.css.map */
